import type { IconData } from '@stacksjs/iconify-core'

export const yahoo: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16.077 2.96c-.489.132-4.957 3.597-5.252 4.448c-.064.293.007 3.141.072 3.568c.294.066 2.42.009 2.81.074l-.047.88c-.382-.03-3.083-.023-4.624-.023c-.783 0-3.3.087-4.074.065l.146-.838c.424-.032 2.18.078 2.565-.332c.191-.204.131-2.91.066-3.368c-.162-.49-4.078-5.397-5.102-6.2H0V0h8.895v.085c.008 0 .022.001.03.003l-.03.208v.937H6.213c1.195 1.749 2.91 3.86 3.64 4.873l3.583-3.246h-2.13l-.3-1.232h7.801l-.058.087l.028.002l-.557.808l-.018.003l-.225.332h-1.439c-.186.04-.35.077-.461.1m2.545 7.726l-.688-.034l-.769-.094l.007 1.317l.606.052l.653.048l.191-1.29zm1.337-6.297c-.232-.008-2.345-.208-2.62-.262l.032 5.564l1.196.097z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default yahoo
